import { merge, get, set } from 'lodash';
import { ACTIONALBUM } from '../../../actionTypes';
let initState = {
	list: []
};
export function AdminAlbumReducers(state = initState, action) {
	switch (action.type) {
		case ACTIONALBUM.SET_ALBUM_LIST: {
			return state;
		}
		default:
			return state;
	}
}
